"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyClassWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LobbyClassWindowModule = _interopRequireDefault(require("./LobbyClassWindow.module.scss"));

var _LobbyClassButton = _interopRequireDefault(require("./components/LobbyClassButton/LobbyClassButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function LobbyClassWindow(_ref) {
  var onChange = _ref.onChange,
      _ref$selectedCharacte = _ref.selectedCharacterClassId,
      selectedCharacterClassId = _ref$selectedCharacte === void 0 ? "" : _ref$selectedCharacte,
      _ref$allowedCharacter = _ref.allowedCharacterClassIds,
      allowedCharacterClassIds = _ref$allowedCharacter === void 0 ? [] : _ref$allowedCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var selectEntry = (0, _react.useCallback)(function (characterClassId) {
    if (onChange) onChange(characterClassId);
  }, [onChange]);
  var renderEntry = (0, _react.useCallback)(function (pos, characterClassId, label) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _LobbyClassWindowModule.default[characterClassId]
    }, /*#__PURE__*/_react.default.createElement(_LobbyClassButton.default, {
      characterClassId: characterClassId,
      label: label,
      direction: pos,
      isSelected: selectedCharacterClassId === characterClassId,
      isDisabled: !allowedCharacterClassIds.includes(characterClassId),
      onClick: function onClick() {
        if (allowedCharacterClassIds.includes(characterClassId)) selectEntry(characterClassId);
      }
    }));
  }, [allowedCharacterClassIds, selectEntry, selectedCharacterClassId]); // TODO: i18n labels from data

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbyClassWindowModule.default.window, className),
    style: style
  }, renderEntry("LEFT", "warrior", "Warrior"), renderEntry("RIGHT", "knight", "Knight"), renderEntry("LEFT", "paladin", "Paladin"), renderEntry("RIGHT", "archer", "Archer"), renderEntry("LEFT", "wizard", "Wizard"), renderEntry("RIGHT", "cleric", "Cleric"), renderEntry("LEFT", "necromancer", "Necromancer"), renderEntry("RIGHT", "summoner", "Summoner"));
}